import React from 'react';
import {withRouter, Route} from 'react-router-dom';
import {  Body2, Caption } from '@material/react-typography';
import { useMediaPredicate } from "react-media-hook";

import Home from './Components/Home/Home';
import Dashboard from './Components/Dashboard/Dashboard'
import SurveezToolbar from './Components/SurveezToolbar/SurveezToolbar'

import './App.scss';
import {ThemeContext, themes} from './themeContext';
import {Helmet} from "react-helmet";

import routes from './routes';
import twitter from './assets/twitter.svg';
//import instagram from './assets/instagram.svg';
import behance from './assets/behance.svg';
import datavizData19 from './data/dataviz-survey-results.json';
//import sampleData from './data/dataviz-survey-results-sample.json';
//import NPSDashboardContainer from './Components/NPSDashboard/NPSDashboardContainer';


function App({props}) {
  const domainName = 'surveez';

  const isMediumScreen = useMediaPredicate("(min-width: 768px)");
  const isLargeScreen = useMediaPredicate("(min-width: 1024px)");
  let themeObj = null;
  if (window.location.pathname.includes('/dashboard')) {
     themeObj = {theme: themes.learn, changeTheme: ()=>{} }
  } else {
     themeObj = {theme: themes.browse, changeTheme: ()=>{} }
  }

 // console.log(isMediumScreen)
  return (
    <div className="App">
        <Helmet>
            <meta charSet="utf-8" />
            <meta name="description" content="data driven blog"/>
            <title>Surveez</title>
            <link rel="canonical" href="https://surveez.netlify.com/" />
          </Helmet>
       <ThemeContext.Provider value={themeObj}> 
         <SurveezToolbar />
       </ThemeContext.Provider>
         {/* <div className="app-toolbar">
                  <Headline4 className="headline6">Surveez</Headline4>
          </div> */}
      
      {/* <Route exact path="/"  component={Home}/> */}
      {/* <Route exact path={routes.home}  component={Home}/> */}
      <Route exact path="/" render={(props)=> <Home {...props} isMediumScreen={isMediumScreen} isLargeScreen={isLargeScreen}/>} />
      {/* <Route exact path={routes.home} render={(props)=> <Home {...props} isMediumScreen={isMediumScreen} isLargeScreen={isLargeScreen}/>} /> */}
      {/* <Route exact path={routes.dashboard} render={(props)=> <NPSDashboardContainer data={sampleData}  {...props} isMediumScreen={isMediumScreen} isLargeScreen={isLargeScreen}/>} />  */}
      <Route exact path={routes.dashboard} render={
            (props)=>
           <ThemeContext.Provider value={themeObj}> 
                <Dashboard data={datavizData19}   {...props} isMediumScreen={isMediumScreen} isLargeScreen={isLargeScreen}/>
             </ThemeContext.Provider>  
          }
        />            
      <div className="app-bottomToolbar">
      <div className="social"> 
                 <div className="sharing">
                    <Body2  className="body2">Tell your friends about this dashboard</Body2>
                          {/* Sharingbutton Faceboo */}
                          <a className="resp-sharing-button__link" href={`https://facebook.com/sharer/sharer.php?u=https%3A%2F%2F${domainName}.netlify.com`} target="_blank" rel="noopener noreferrer" aria-label="">
                            <div className="resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small"><div aria-hidden="true" className="resp-sharing-button__icon resp-sharing-button__icon--solid">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"/></svg>
                              </div>
                            </div>
                          </a>

                          {/* Sharingbutton Twitter */}
                          <a className="resp-sharing-button__link" href={`https://twitter.com/intent/tweet/?text=Explore%20the%20datavisualization%20presentation%20survey%20with%20this%20data%20visualization%20dashboard&amp;url=https%3A%2F%2F${domainName}.netlify.com`} target="_blank" rel="noopener noreferrer" aria-label="">
                            <div className="resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small"><div aria-hidden="true" className="resp-sharing-button__icon resp-sharing-button__icon--solid">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z"/></svg>
                              </div>
                            </div>
                          </a>
 
                  </div>
                  <div className="follow-container">
                    <Body2 className="body2">Connect With Rapid Developer</Body2>
                        {/* <a href="https://www.instagram.com/rapiddeveloper" id="instagram" target="_blank" rel="noopener noreferrer" aria-label="">
                            <img src={instagram} alt="instagram"/>
                        </a> */}
                        <a id="twitter" href="https://twitter.com/rapid_developer?ref_src=twsrc%5Etfw" className="twitter-follow-button" aria-label="" data-show-count="false">
                              <img src={twitter} alt="twitter"/>
                        </a>
                        <a id="behance" href="https://www.behance.net/jobiejabez3f47?isa0=1" className="behance-follow-button" aria-label="" data-show-count="false">
                              <img src={behance} alt="behance"/>
                        </a>
                  </div>
                </div>
              <div>
                <Caption className="caption">Icons made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank" rel="noopener noreferrer" >CC 3.0 BY</a></Caption>             
                <Caption>Author Rapid Developer</Caption>
             </div>
      </div>
    </div>
  );
}


export default withRouter(App);
